<template>
  <div>
    <section class="originality">
        <div class="tabs">
            <div :class="{ 'actived': actived === 0 }" @click="tab(0)">包包</div>
            <div :class="{ 'actived': actived === 1 }" @click="tab(1)">鞋靴</div>
            <div :class="{ 'actived': actived === 2 }" @click="tab(2)">衣裤</div>
            <div :class="{ 'actived': actived === 3 }" @click="tab(3)">配饰</div>
        </div>
        <div class="container">
            <van-swipe :loop="false" :show-indicators='false' class='swiper' @change='change' ref='swiper'>
                <van-swipe-item class='swiper_item'> 
                    <div class='bag'>
                        <div v-for='(item,index) in bagList3' :key='index' @click='todetail(item)'>
                            <img :src='item.pic | formatImgUrl(310,196,true)'>
                            <div class='dero'>
                                <span>{{item.name}}</span>
                                <span>¥{{item.price}}</span>
                            </div>
                            <div class='saleNum'>已售{{item.totalSalesNumber}}件</div>
                        </div>
                    </div>
                </van-swipe-item>
                <van-swipe-item class='swiper_item'> 
                    <div class='bag'>
                        <div v-for='(item,index) in bagList4' :key='index' @click='todetail(item)'>
                            <img :src='item.pic | formatImgUrl(310,196,true)'>
                            <div class='dero'>
                                <span>{{item.name}}</span>
                                <span>¥{{item.price}}</span>
                            </div>
                            <div class='saleNum'>已售{{item.totalSalesNumber}}件</div>
                        </div>
                    </div>
                </van-swipe-item>
                <van-swipe-item class='swiper_item'> 
                    <div class='bag'>
                        <div v-for='(item,index) in bagList5' :key='index' @click='todetail(item)'>
                            <img :src='item.pic | formatImgUrl(310,196,true)'>
                            <div class='dero'>
                                <span>{{item.name}}</span>
                                <span>¥{{item.price}}</span>
                            </div>
                            <div class='saleNum'>已售{{item.totalSalesNumber}}件</div>
                        </div>
                    </div>
                </van-swipe-item>
                <van-swipe-item class='swiper_item'> 
                    <div class='bag'>
                        <div v-for='(item,index) in bagList6' :key='index' @click='todetail(item)'>
                            <img :src='item.pic | formatImgUrl(310,196,true)'>
                            <div class='dero'>
                                <span>{{item.name}}</span>
                                <span>¥{{item.price}}</span>
                            </div>
                            <div class='saleNum'>已售{{item.totalSalesNumber}}件</div>
                        </div>
                    </div>
                </van-swipe-item>
            </van-swipe>
            
            <div class='more'>
                <img src='/images/newIndex/more.png' @click='toList'>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
    import homeApi from '@/axios/home'
    import zhugeObj from '@/assets/js/track'
    export default {
        name: "originality",

        props:{

        },
        data() {
            return {
                actived : 0,
                bagList3 : [

                ],
                bagList4 : [

                ],
                bagList5 : [

                ],
                bagList6 : [

                ],
                dataNum : {}
                
            }
        },

        computed: {

        },
        directives : {

        },
        created() {
            // this.getSalesNumber();
            this.getList(3);
            this.getList(4);
            this.getList(5);
            this.getList(6);
        },
        mounted() {

        },

        methods: {
            getList(index){
                let params = {
                    current : 1,
                    size : 100,
                    categoryId : index
                }

                homeApi.curingServiceGoodsPart(params).then((res)=>{
                     if(index == 3){
                        this.bagList3 = res.records.slice(0,4);
                    }
                    if(index == 4){
                        this.bagList4 = res.records.slice(0,4);
                    }
                    if(index == 5){
                        this.bagList5 = res.records.length>5?res.records.slice(1,5):res.records;
                    }
                    if(index == 6){
                        this.bagList6 = res.records.length>5?res.records.slice(1,5):res.records;
                    }
                })
            },
            todetail(item){
          
                zhugeObj.track({
                    title : '首页-点击匠心修',
                    content : {
                        '品类' : item.categoryName,
                        '服务项名称' : item.name
                    }
                })
                this.$router.push({ name : 'serviceDetail' , query:{serviceId:item.id}});
            },
            change(index){
                this.actived = index;
            },  
            tab(index){
                this.actived = index;
                this.$refs.swiper.swipeTo(index);
                if(index == 0){
                    zhugeObj.track({
                        title : '首页—养护服务',
                        content : {
                            '匠心修' : '包包',
               
                        }
                    })
                }else if(index == 1){
                    zhugeObj.track({
                        title : '首页—养护服务',
                        content : {
                            '匠心修' : '鞋靴',
                        
                        }
                    })
                }else if(index == 2){
                    zhugeObj.track({
                        title : '首页—养护服务',
                        content : {
                            '匠心修' : '衣裤',
             
                        }
                    })
                }else if(index == 3){
                    zhugeObj.track({
                        title : '首页—养护服务',
                        content : {
                            '匠心修' : '佩饰',
                  
                        }
                    })
                }
                // this.getList();
            },
            toList(){
                zhugeObj.track({
                    title : '首页—养护服务',
                    content : {
                        '匠心修' : '更多',
                    }
                })
                this.$router.push({name:'homeListNew',query:{type:this.actived}})
            },
        
        }
        
    }
</script>

<style scoped lang="scss">
    // .originality{
    //     margin-left: 16px;
    //     margin-right: 16px;
    // }
    .swiper_item{
        // padding-left:5px;
        // padding-right: 5px;
    }
    .bag{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding-left: 5px;
        padding-right: 5px;
        &>div{
            margin-top:40px;
        }
        img{
            width: 330px;
            border-radius:5px; 
        }
        .dero{
            display: flex;
            justify-content: space-between;
            font-size: 28px;
            color:#4A4A4A;
            margin-top: 20px;;
            margin-bottom: 12px;
        }
        .saleNum{
            color:#9B9B9B;
            font-size: 16px;
        }
    }
    .more{
        display: flex;
        justify-content: center;
        margin-top: 40px;
        img{
            width: 140px;
            height: 34px;
        }
    }
    .home-list{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .tabs{
        // padding: 0 52px;
        // width: 648px;
        margin-top: 20px;
        margin-left: 32px;
        margin-right: 32px;
        // padding:0 16px;
        height: 90px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom:1px solid #9B9B9B; 
        box-sizing: border-box;
        &>div{
            position: relative;
            top:1px;
            width: 100px;
            height: 88px;
            border-bottom: 2px solid transparent;
            display: inline-block;
            line-height: 88px;
            text-align: center;
            box-sizing: border-box;
            &.actived{
                border-bottom: 4px solid #4A4A4A;
                color:#4A4A4A;
            }
        }
    }
    .container{
        margin-left: 25px;
        margin-right:25px;

        .van-list{
            overflow-y: scroll;
            padding: 0 30px;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            height: 100%;
            &>div{
                margin-bottom: 20px;
                &:nth-child(2n){
                    margin-left: 18px;
                }
            }
        }
    }
</style>
